import { FC } from 'react';
import victim from 'images/victim-icon.svg';

interface VictimIconProps {
  width: string;
  height: string;
}

const VictimIcon: FC<VictimIconProps> = (props): JSX.Element => {
  const { width, height } = props;
  return <img width={width} height={height} src={victim} alt="request-icon" />;
};
export default VictimIcon;
